/* V_PT_PROD_CARD_16 | Blog Sticky CTA — Product Card with Bottom Sheet
   Reveal behaviour for the mobile blog sticky CTA.
   - Var A (bottom sheet) is handled natively by quick-add.js via .js-quick-add
   - Var B (direct add-to-cart) is handled natively by product-form.js
   The bar stays hidden while the first-paint content is in view, and slides up
   once the visitor has scrolled past the first viewport. */
(function () {
  "use strict";

  function initBlogStickyCta() {
    var sticky = document.querySelector(".c-blogStickyCta");
    if (!sticky) return;

    var ticking = false;
    var footerVisible = false;

    function evaluate() {
      ticking = false;
      // Show once everything from the first paint has scrolled up out of view
      // (i.e. the visitor has scrolled past the first viewport); hide near the
      // top and also once the footer comes into view.
      var show = window.scrollY >= window.innerHeight && !footerVisible;
      sticky.classList.toggle("c-blogStickyCta--revealed", show);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });

    // Hide the bar as soon as the page footer starts to appear.
    var footer = document.querySelector("footer.footer, .footer");
    if (footer && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        evaluate();
      }).observe(footer);
    }

    evaluate();

    fixDrawerEscapedPrices();
  }

  // The Var A bottom sheet (quick-add drawer) renders the subscription/price
  // fields with the shop's money_format, which wraps the amount in
  // <span class="money">…</span>. quick-add.js sets those fields via textContent,
  // so the markup shows as raw text (e.g. "<span class=money>€15.99</span>").
  // Watch the drawer and re-parse any price field whose text contains HTML.
  function fixDrawerEscapedPrices() {
    var drawer = document.querySelector("quick-add-drawer");
    if (!drawer || !("MutationObserver" in window)) return;

    var SELECTOR =
      ".form-subscription__cta-price, .form-subscription__cta-compare, " +
      ".price__current, .price__was, .quick-add-btn-text";

    function fix() {
      drawer.querySelectorAll(SELECTOR).forEach(function (el) {
        // Only act on a text node that still contains raw markup.
        if (el.children.length === 0 && el.textContent.indexOf("<") !== -1) {
          el.innerHTML = el.textContent;
        }
      });
    }

    new MutationObserver(fix).observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBlogStickyCta);
  } else {
    initBlogStickyCta();
  }
})();
